const lastMarginLeftLPulsPX = 25

export const breadcrumbLastItems = (index: number) => ({
  marginLeft: `${index * lastMarginLeftLPulsPX}px`,
})
